import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tgx-web-site-public-v3-sign-up',
  templateUrl: './v3-sign-up.component.html',
  styleUrls: ['./v3-sign-up.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class V3SignUpComponent {}
